(function() {
  var ROOT_SELECTOR = '[data-ru-product-bundle]';
  var STORAGE_PREFIX = 'ruProductBundle:v1:';

  function parseJson(root) {
    var script = root.querySelector('[data-ru-bundle-json]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.theme && window.theme.moneyFormat || '{{amount}}\u20ac';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;

      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var euros = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return euros + centsPart;
    }

    switch ((formatString.match(placeholderRegex) || [])[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 0);
    }

    return formatString.replace(placeholderRegex, value).replace(/<[^>]*>/g, '');
  }

  function normalizeLabel(value, fallback) {
    value = value || fallback || 'Producto';
    return String(value).trim();
  }

  function singularLabel(value) {
    value = normalizeLabel(value, 'Producto');
    return value.length > 3 && value.slice(-1).toLowerCase() === 's' ? value.slice(0, -1) : value;
  }

  function summaryLineTitle(step) {
    return normalizeLabel(step.label, 'Producto')
      .replace(/^\d+\s*\+\s*\d+\s*/, '1 ')
      .toUpperCase();
  }

  function variantLabel(variant) {
    if (!variant) return '';
    if (variant.option1 && variant.option1 !== 'Default Title') return variant.option1;
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    return '';
  }

  function availableVariants(product) {
    return (product.variants || []).filter(function(variant) {
      return variant.available;
    });
  }

  function firstAvailableVariant(product) {
    return availableVariants(product)[0] || (product.variants || [])[0] || null;
  }

  function singleVariantProduct(product) {
    var variants = product.variants || [];
    return variants.length === 1 ? variants[0] : null;
  }

  function selectedVariantForAdd(product, select, onlyVariant) {
    if (onlyVariant) return onlyVariant;
    if (!select.value) return null;
    return (product.variants || []).find(function(item) {
      return String(item.id) === String(select.value);
    });
  }

  function isProductAddSoldOut(product, select, onlyVariant) {
    if (!availableVariants(product).length) return true;
    var variant = selectedVariantForAdd(product, select, onlyVariant);
    return variant ? !variant.available : false;
  }

  function refreshProductAddButton(add, product, select, onlyVariant, config) {
    var soldOut = isProductAddSoldOut(product, select, onlyVariant);
    var hasSelection = !!(onlyVariant || select.value);
    var soldOutLabel = config.soldOutLabel || 'Agotado';

    add.textContent = '';
    add.classList.toggle('is-sold-out', soldOut);

    if (soldOut) {
      add.disabled = true;
      add.textContent = soldOutLabel;
      add.setAttribute('aria-label', soldOutLabel);
      return;
    }

    add.disabled = !hasSelection;
    add.setAttribute('aria-label', 'Añadir al pack');

    if (config.iconUrl) {
      add.appendChild(createAddToCartIcon(config.iconUrl));
    }
  }

  function discountedPrice(price, discountPercent) {
    if (!discountPercent) return price;
    return Math.round(price * (100 - discountPercent) / 100);
  }

  function variantHasStoreCompare(variant) {
    return variant && variant.compareAtPrice && variant.compareAtPrice > variant.price;
  }

  function appendStorefrontVariantPrice(container, variant, moneyFormat, options) {
    if (!variant) return;

    options = options || {};
    var saleClass = options.saleClass != null ? options.saleClass : 'RuProductBundleProduct__priceSale';
    var compareClass = options.compareClass != null ? options.compareClass : 'RuProductBundleProduct__priceCompare';
    var priceText = variant.priceText || formatMoney(variant.price, moneyFormat);

    if (variantHasStoreCompare(variant)) {
      if (options.onSaleContainerClass) {
        container.classList.add(options.onSaleContainerClass);
      }
      container.appendChild(createElement('span', saleClass, priceText));
      container.appendChild(createElement('span', compareClass, variant.compareAtPriceText || formatMoney(variant.compareAtPrice, moneyFormat)));
      return;
    }

    container.appendChild(createElement('span', options.regularClass || 'RuProductBundleProduct__priceRegular', priceText));
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }

  function createAddToCartIcon(iconUrl) {
    var img = createElement('img', 'RuProductBundleProduct__addIcon');
    img.src = iconUrl;
    img.alt = '';
    img.width = 18;
    img.height = 18;
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('decoding', 'async');
    img.loading = 'lazy';
    return img;
  }

  function createSelectArrowIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'Icon Icon--select-arrow');
    svg.setAttribute('role', 'presentation');
    svg.setAttribute('viewBox', '0 0 19 12');
    svg.setAttribute('aria-hidden', 'true');

    var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    polyline.setAttribute('fill', 'none');
    polyline.setAttribute('stroke', 'currentColor');
    polyline.setAttribute('points', '17 2 9.5 10 2 2');
    polyline.setAttribute('fill-rule', 'evenodd');
    polyline.setAttribute('stroke-width', '2');
    polyline.setAttribute('stroke-linecap', 'square');
    svg.appendChild(polyline);
    return svg;
  }

  function closeBundleSizeDropdowns(exceptPopover) {
    document.querySelectorAll('.RuProductBundleProduct__options[aria-hidden="false"]').forEach(function(popover) {
      if (exceptPopover && popover === exceptPopover) return;
      popover.setAttribute('aria-hidden', 'true');
      var trigger = popover.previousElementSibling;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function createBundleSizeSelector(product, selectedVariant, onlyVariant) {
    var wrap = createElement('div', 'RuProductBundleProduct__sizeSelector');
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.className = 'RuProductBundleProduct__select';
    hidden.value = '';

    var trigger = createElement('div', 'RuProductBundleProduct__selectTrigger ProductForm__Itema ProductForm__Itema--custom');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-expanded', 'false');

    var optionName = createElement('span', 'ProductForm__OptionName');
    var selectedValue = createElement('span', 'ProductForm__SelectedValue', 'Size');
    optionName.appendChild(selectedValue);
    trigger.appendChild(optionName);
    trigger.appendChild(createSelectArrowIcon());

    var popover = createElement('div', 'RuProductBundleProduct__options OptionSelectora');
    popover.setAttribute('aria-hidden', 'true');

    var content = createElement('div', 'Popover__Content');
    var list = createElement('div', 'Popover__ValueList');
    list.setAttribute('data-scrollable', '');

    (product.variants || []).forEach(function(variant) {
      var label = variantLabel(variant) || variant.title;
      var button = createElement('button', 'Popover__Value Title2 Link Link--primary u-h6', label);
      button.type = 'button';
      button.setAttribute('data-value', label);
      button.setAttribute('data-variant-id', variant.id);
      button.setAttribute('data-action', 'select-value');

      if (!variant.available) {
        button.classList.add('sold_out');
        button.disabled = true;
      }

      if (selectedVariant && String(selectedVariant.id) === String(variant.id)) {
        button.classList.add('is-selected');
        hidden.value = variant.id;
        selectedValue.textContent = label;
      }

      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!variant.available) return;

        list.querySelectorAll('.Popover__Value').forEach(function(item) {
          item.classList.remove('is-selected');
        });
        button.classList.add('is-selected');
        hidden.value = variant.id;
        selectedValue.textContent = label;
        popover.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.classList.remove('is-validation-error');
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      });

      list.appendChild(button);
    });

    content.appendChild(list);
    popover.appendChild(content);

    if (onlyVariant) {
      hidden.value = onlyVariant.id;
      selectedValue.textContent = 'One Size';
      trigger.classList.add('is-single-variant');
      trigger.setAttribute('aria-disabled', 'true');
      trigger.removeAttribute('tabindex');
    } else {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        var isOpen = popover.getAttribute('aria-hidden') !== 'false';
        closeBundleSizeDropdowns(isOpen ? null : popover);
        popover.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      trigger.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
    }

    wrap.appendChild(hidden);
    wrap.appendChild(trigger);
    wrap.appendChild(popover);
    return { wrap: wrap, select: hidden, trigger: trigger };
  }

  function createRemoveSelectionButton(removeLabel, onRemove) {
    var button = createElement('button', 'RuProductBundleSummary__remove CartItem__Remove Link Link--underline Link--underlineShort');
    button.type = 'button';
    button.textContent = removeLabel;
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      onRemove();
    });
    return button;
  }

  function createEmptyBundleSlot(step, stepIndex, onOpenStep) {
    var slot = createElement('button', 'RuProductBundleSlot RuProductBundleSlot--empty');
    slot.type = 'button';
    slot.setAttribute('data-ru-bundle-slot', String(stepIndex));
    slot.setAttribute('aria-label', step.label || '');
    slot.appendChild(createElement('span', 'RuProductBundleSlot__plus', '+'));
    slot.addEventListener('click', function(event) {
      event.preventDefault();
      onOpenStep(step);
    });
    return slot;
  }

  function ProductBundle(root) {
    this.root = root;
    this.data = parseJson(root);
    if (!this.data || !this.data.bundles || !this.data.bundles.length) return;

    this.addIconUrl = this.data.addIconUrl || '';
    this.soldOutLabel = this.data.soldOutLabel || 'Agotado';
    this.modifyLabel = this.data.modifyLabel || 'MODIFICAR';
    this.removeLabel = this.data.removeLabel || 'Eliminar';
    this.mainSizeHint = normalizeLabel(this.data.mainSizeHint, 'Elige tu talla');
    this.headerToggle = root.querySelector('[data-ru-bundle-toggle]');
    this.packsWrapper = root.querySelector('[data-ru-bundle-packs]');
    this.packButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ru-bundle-pack]'));
    this.modal = root.querySelector('[data-ru-bundle-modal]');
    this.modalDialog = root.querySelector('.RuProductBundleModal__dialog');
    this.modalTitle = root.querySelector('[data-ru-bundle-modal-title]');
    this.modalSubtitle = root.querySelector('[data-ru-bundle-modal-subtitle]');
    this.modalDiscount = root.querySelector('[data-ru-bundle-modal-discount]');
    this.stepsWrapper = root.querySelector('[data-ru-bundle-steps]');
    this.summary = root.querySelector('[data-ru-bundle-summary]');
    this.summaryToggle = root.querySelector('[data-ru-bundle-summary-toggle]');
    this.slotsWrapper = root.querySelector('[data-ru-bundle-slots]');
    this.detailsWrapper = root.querySelector('[data-ru-bundle-details]');
    this.totalWrapper = root.querySelector('[data-ru-bundle-total]');
    this.submitButton = root.querySelector('[data-ru-bundle-submit]');
    this.closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ru-bundle-close]'));
    this.storageKey = STORAGE_PREFIX + this.data.productId;
    this.state = {
      pack: null,
      steps: [],
      activeStep: 0,
      selections: {}
    };

    this.bind();
    this.bindNavOffsetSync();
  }

  ProductBundle.prototype.getMainNavElement = function() {
    return document.querySelector('.js-hide-nav--main');
  };

  ProductBundle.prototype.isMainNavVisible = function() {
    var mainNav = this.getMainNavElement();
    if (!mainNav) return true;
    if (mainNav.classList.contains('hide-nav--off-canvas')) return false;
    return mainNav.getBoundingClientRect().bottom > 1;
  };

  ProductBundle.prototype.syncModalNavOffset = function() {
    if (!this.modalDialog) return;

    if (!window.matchMedia('(min-width: 768px)').matches) {
      this.modalDialog.classList.remove(
        'RuProductBundleModal__dialog--nav-visible',
        'RuProductBundleModal__dialog--nav-hidden'
      );
      return;
    }

    var isVisible = this.isMainNavVisible();
    this.modalDialog.classList.toggle('RuProductBundleModal__dialog--nav-visible', isVisible);
    this.modalDialog.classList.toggle('RuProductBundleModal__dialog--nav-hidden', !isVisible);
  };

  ProductBundle.prototype.bindNavOffsetSync = function() {
    var self = this;
    var mainNav = this.getMainNavElement();

    this._onNavOffsetChange = function() {
      if (!self.modal || !self.modal.classList.contains('is-open')) return;
      self.syncModalNavOffset();
    };

    if (mainNav && typeof MutationObserver !== 'undefined') {
      this.navOffsetObserver = new MutationObserver(this._onNavOffsetChange);
      this.navOffsetObserver.observe(mainNav, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    window.addEventListener('scroll', this._onNavOffsetChange, { passive: true });
    window.addEventListener('resize', this._onNavOffsetChange);
  };

  ProductBundle.prototype.bind = function() {
    var self = this;

    if (this.headerToggle && this.packsWrapper) {
      this.headerToggle.addEventListener('click', function() {
        var isExpanded = self.headerToggle.getAttribute('aria-expanded') === 'true';
        self.headerToggle.setAttribute('aria-expanded', String(!isExpanded));
        self.packsWrapper.hidden = isExpanded;
        var icon = self.headerToggle.querySelector('.RuProductBundle__toggleIcon');
        if (icon) icon.textContent = isExpanded ? '+' : '-';
      });
    } else if (this.headerToggle) {
      var toggleIcon = this.headerToggle.querySelector('.RuProductBundle__toggleIcon');
      if (toggleIcon) toggleIcon.hidden = true;
      this.headerToggle.setAttribute('aria-expanded', 'true');
    }

    this.packButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var packId = parseInt(button.getAttribute('data-ru-bundle-pack'), 10);
        var pack = (self.data.bundles || []).find(function(item) {
          return item.id === packId;
        });

        if (pack && pack.packSteps && pack.packSteps.length) {
          self.openPack(pack);
        }
      });
    });

    this.closeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        self.closeModal();
      });
    });

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', function() {
        if (!window.matchMedia('(max-width: 1007px)').matches) return;
        self.setSummaryExpanded(!self.summary.classList.contains('is-expanded'));
      });
    }

    if (this.submitButton) {
      this.submitButton.addEventListener('click', function() {
        if (self.submitButton.classList.contains('is-disabled')) {
          self.showValidationErrors();
          return;
        }
        self.addToCart();
      });
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && self.modal && self.modal.classList.contains('is-open')) {
        closeBundleSizeDropdowns();
        self.closeModal();
      }
    });

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.RuProductBundleProduct__sizeSelector')) {
        closeBundleSizeDropdowns();
      }
    });
  };

  ProductBundle.prototype.getCartJsonUrl = function() {
    return this.data.cartJsonUrl || (window.routes && window.routes.cartUrl ? window.routes.cartUrl + '.js' : '/cart.js');
  };

  ProductBundle.prototype.getCartAddUrl = function() {
    return this.data.cartAddUrl || (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl + '.js' : '/cart/add.js');
  };

  ProductBundle.prototype.getCartChangeUrl = function() {
    return this.data.cartChangeUrl || (window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl + '.js' : '/cart/change.js');
  };

  ProductBundle.prototype.fetchCart = function() {
    return fetch(this.getCartJsonUrl(), { credentials: 'same-origin' }).then(function(response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  };

  ProductBundle.prototype.findCartItemByProductId = function(cart, productId) {
    return (cart.items || []).find(function(item) {
      return String(item.product_id) === String(productId);
    });
  };

  ProductBundle.prototype.findCartItemByVariantId = function(cart, variantId) {
    return (cart.items || []).find(function(item) {
      return String(item.variant_id) === String(variantId);
    });
  };

  ProductBundle.prototype.createSelection = function(product, variant, cartItem) {
    var selection = {
      product: product,
      variant: variant
    };

    if (cartItem) {
      selection.cartLineKey = cartItem.key;
      selection.cartVariantId = cartItem.variant_id;
    }

    return selection;
  };

  // DISABLED: Pre-fills bundle steps from products already in the cart (shows checkmarks / selected text on open).
  // To restore: uncomment this function body and the fetchCart + applyCartSelections block in openPack below.
  ProductBundle.prototype.applyCartSelections = function(pack, cart) {
    /*
    var self = this;
    var mainStep = this.state.steps.find(function(step) {
      return step.isMain;
    });

    if (mainStep && pack.mainProduct) {
      var mainCartItem = this.findCartItemByProductId(cart, pack.mainProduct.id);
      if (mainCartItem) {
        var mainProduct = mainStep.products[0];
        var mainVariant = (mainProduct.variants || []).find(function(variant) {
          return String(variant.id) === String(mainCartItem.variant_id);
        });

        if (mainVariant) {
          this.state.selections[mainStep.key] = this.createSelection(mainProduct, mainVariant, mainCartItem);
        }
      }
    }

    this.state.steps.forEach(function(step) {
      if (step.isMain || self.state.selections[step.key]) return;

      step.products.forEach(function(product) {
        if (self.state.selections[step.key]) return;

        var cartItem = self.findCartItemByProductId(cart, product.id);
        if (!cartItem) return;

        var variant = (product.variants || []).find(function(item) {
          return String(item.id) === String(cartItem.variant_id);
        });

        if (variant) {
          self.state.selections[step.key] = self.createSelection(product, variant, cartItem);
        }
      });
    });

    var firstIncompleteIndex = this.state.steps.findIndex(function(step) {
      return !self.state.selections[step.key];
    });

    if (firstIncompleteIndex !== -1) {
      this.state.activeStep = firstIncompleteIndex;
    }
    */
  };

  ProductBundle.prototype.finishOpenPack = function(pack) {
    this.render();

    if (this.modalTitle) {
      this.modalTitle.textContent = pack.title || this.data.productTitle || '';
    }

    if (this.modalSubtitle) {
      if (pack.subtitle) {
        this.modalSubtitle.textContent = pack.subtitle;
        this.modalSubtitle.hidden = false;
      } else {
        this.modalSubtitle.textContent = '';
        this.modalSubtitle.hidden = true;
      }
    }

    if (this.modalDiscount) {
      this.modalDiscount.hidden = !pack.discountPercent;
      this.modalDiscount.textContent = pack.discountPercent ? '-' + pack.discountPercent + '%' : '';
    }

    if (window.matchMedia('(min-width: 1008px)').matches) {
      this.setSummaryExpanded(true);
    }

    this.syncModalNavOffset();

    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('RuProductBundleNoScroll');
  };

  ProductBundle.prototype.openPack = function(pack) {
    var self = this;

    this.collapseSummary();
    this.state.pack = pack;
    this.state.steps = this.buildSteps(pack);
    this.state.activeStep = 0;
    this.state.selections = {};
    this.submitButton.classList.remove('is-loading');
    this.clearValidationErrors();

    // Bundle always starts empty: user must select all pack items again (no cart pre-fill on open).
    self.finishOpenPack(pack);

    /*
    this.fetchCart()
      .then(function(cart) {
        self.state.cartSnapshot = cart;
        self.applyCartSelections(pack, cart);
      })
      .catch(function() {})
      .then(function() {
        self.finishOpenPack(pack);
      });
    */
  };

  ProductBundle.prototype.setSummaryExpanded = function(expanded) {
    if (!this.summary) return;

    this.summary.classList.toggle('is-expanded', expanded);

    if (this.detailsWrapper) {
      this.detailsWrapper.hidden = window.matchMedia('(max-width: 1007px)').matches && !expanded;
    }

    if (this.summaryToggle) {
      this.summaryToggle.setAttribute('aria-expanded', String(expanded));
    }
  };

  ProductBundle.prototype.collapseSummary = function() {
    this.setSummaryExpanded(false);
  };

  ProductBundle.prototype.closeModal = function() {
    if (!this.modal) return;
    closeBundleSizeDropdowns();
    if (window.matchMedia('(max-width: 1007px)').matches) {
      this.collapseSummary();
    }

    var self = this;
    var finishClose = function() {
      self.modal.classList.remove('is-open', 'is-closing');
      self.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('RuProductBundleNoScroll');
    };

    if (window.matchMedia('(min-width: 768px)').matches) {
      this.modal.classList.add('is-closing');
      var dialog = this.modalDialog;
      var done = false;
      var onEnd = function() {
        if (done) return;
        done = true;
        if (dialog) dialog.removeEventListener('animationend', onEnd);
        finishClose();
      };
      if (dialog) dialog.addEventListener('animationend', onEnd);
      setTimeout(onEnd, 300);
    } else {
      finishClose();
    }
  };

  ProductBundle.prototype.buildSteps = function(pack) {
    var steps = [{
      key: 'main',
      label: normalizeLabel(pack.mainProduct.type, 'Zapatillas'),
      hint: this.mainSizeHint,
      products: [pack.mainProduct],
      isMain: true
    }];

    (pack.packSteps || []).forEach(function(packStep, index) {
      if (!packStep.products || !packStep.products.length) return;

      steps.push({
        key: packStep.key || 'pack-step-' + index,
        label: packStep.label || 'Producto',
        hint: packStep.hint || ('Elige tu ' + (packStep.label || 'producto').toLowerCase()),
        products: packStep.products,
        isMain: false
      });
    });

    return steps;
  };

  ProductBundle.prototype.persistSelections = function() {
    var stored = {};

    try {
      stored = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    } catch (error) {
      stored = {};
    }

    stored[this.state.pack.id] = {};

    Object.keys(this.state.selections).forEach(function(stepKey) {
      var selection = this.state.selections[stepKey];
      stored[this.state.pack.id][stepKey] = {
        productId: selection.product.id,
        variantId: selection.variant.id
      };
    }, this);

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(stored));
    } catch (error) {}
  };

  ProductBundle.prototype.clearValidationErrors = function() {
    this.root.querySelectorAll('.is-validation-error').forEach(function(element) {
      element.classList.remove('is-validation-error');
    });
  };

  ProductBundle.prototype.markIncompleteSteps = function() {
    var self = this;

    this.state.steps.forEach(function(step) {
      if (self.state.selections[step.key]) return;

      var section = self.stepsWrapper.querySelector('[data-ru-bundle-step="' + step.key + '"]');
      if (!section) return;

      var hint = section.querySelector('.RuProductBundleStep__hint');
      if (hint) hint.classList.add('is-validation-error');

      if (step.isMain) {
        section.querySelectorAll('.RuProductBundleSize').forEach(function(button) {
          button.classList.add('is-validation-error');
        });
      } else {
        section.querySelectorAll('.RuProductBundleProduct__selectTrigger').forEach(function(trigger) {
          if (trigger.classList.contains('is-single-variant')) return;
          trigger.classList.add('is-validation-error');
        });
      }
    });
  };

  ProductBundle.prototype.showValidationErrors = function() {
    this.clearValidationErrors();

    var firstIncompleteIndex = this.state.steps.findIndex(function(step) {
      return !this.state.selections[step.key];
    }, this);

    if (firstIncompleteIndex !== -1 && this.state.activeStep !== firstIncompleteIndex) {
      this.state.activeStep = firstIncompleteIndex;
      this.renderSteps();
    }

    var self = this;
    this.markIncompleteSteps();

    var firstIncompleteStep = this.state.steps.find(function(step) {
      return !self.state.selections[step.key];
    });
    if (firstIncompleteStep) {
      var firstIncompleteSection = this.stepsWrapper.querySelector('[data-ru-bundle-step="' + firstIncompleteStep.key + '"]');
      if (firstIncompleteSection) {
        firstIncompleteSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  };

  ProductBundle.prototype.render = function() {
    this.renderSteps();
    this.renderSummary();
  };

  ProductBundle.prototype.renderSteps = function() {
    var self = this;
    this.stepsWrapper.innerHTML = '';

    this.state.steps.forEach(function(step, index) {
      var selection = self.state.selections[step.key];
      var section = createElement('section', 'RuProductBundleStep');
      section.setAttribute('data-ru-bundle-step', step.key);
      if (index === self.state.activeStep) section.classList.add('is-open');
      if (selection) section.classList.add('is-complete');

      var head = createElement('button', 'RuProductBundleStep__head');
      head.type = 'button';
      head.setAttribute('aria-expanded', index === self.state.activeStep ? 'true' : 'false');
      head.addEventListener('click', function() {
        self.state.activeStep = self.state.activeStep === index ? -1 : index;
        self.renderSteps();
      });

      var label = createElement('span', 'RuProductBundleStep__label', step.label.toUpperCase());
      var selectedDisplay = '';
      if (selection) {
        var vLabel = variantLabel(selection.variant) || (selection.variant.title !== 'Default Title' ? selection.variant.title : '');
        selectedDisplay = selection.product.title + (vLabel ? ' (' + vLabel + ')' : '');
      }
      var selectedText = createElement('span', 'RuProductBundleStep__selectedText', selectedDisplay);
      var check = createElement('span', 'RuProductBundleStep__check', '\u2713');
      var plus = createElement('span', 'RuProductBundleStep__plus', '+');

      head.appendChild(label);
      head.appendChild(selectedText);
      head.appendChild(check);
      head.appendChild(plus);

      var body = createElement('div', 'RuProductBundleStep__body');
      body.appendChild(createElement('p', 'RuProductBundleStep__hint', step.hint + ':'));

      if (step.isMain) {
        body.appendChild(self.renderMainStep(step));
      } else {
        body.appendChild(self.renderProductStep(step));
      }

      section.appendChild(head);
      section.appendChild(body);
      self.stepsWrapper.appendChild(section);
    });
  };

  ProductBundle.prototype.renderMainStep = function(step) {
    var self = this;
    var product = step.products[0];
    var variants = product.variants || [];
    var list = createElement('div', 'RuProductBundleSizeList');

    if (variants.length === 1 && !variantLabel(variants[0])) {
      var selectProduct = createElement('button', 'RuProductBundleSize', 'Seleccionar');
      selectProduct.type = 'button';
      selectProduct.disabled = !variants[0].available;
      selectProduct.addEventListener('click', function() {
        self.selectStep(step, product, variants[0]);
      });
      list.appendChild(selectProduct);
      return list;
    }

    variants.forEach(function(variant) {
      var button = createElement('button', 'RuProductBundleSize', variantLabel(variant) || variant.title);
      button.type = 'button';
      button.disabled = !variant.available;

      var selected = self.state.selections[step.key];
      if (selected && String(selected.variant.id) === String(variant.id)) {
        button.classList.add('is-selected');
      }

      button.addEventListener('click', function() {
        button.classList.remove('is-validation-error');
        self.selectStep(step, product, variant);
      });

      list.appendChild(button);
    });

    return list;
  };

  ProductBundle.prototype.renderProductStep = function(step) {
    var self = this;
    var grid = createElement('div', 'RuProductBundleProductGrid');

    step.products.forEach(function(product) {
      var card = createElement('article', 'RuProductBundleProduct');
      var imageWrap = createElement('div', 'RuProductBundleProduct__imageWrap');
      var image = null;
      if (product.image) {
        image = createElement('img', 'RuProductBundleProduct__image');
        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      }

      var info = createElement('div', 'RuProductBundleProduct__info');
      var meta = createElement('div', 'RuProductBundleProduct__meta');
      meta.appendChild(createElement('p', 'RuProductBundleProduct__title', product.title));
      meta.appendChild(createElement('p', 'CartProductItem__ModelName', product.model || ''));

      info.appendChild(meta);

      var price = createElement('div', 'RuProductBundleProduct__price');
      var firstVariant = firstAvailableVariant(product);
      // Product grid: storefront price only (no bundle %). Bundle discount stays in RuProductBundleSummary__details.
      appendStorefrontVariantPrice(price, firstVariant, self.data.moneyFormat);
      /*
      if (firstVariant) {
        var salePrice = discountedPrice(firstVariant.price, self.state.pack.discountPercent);
        price.appendChild(createElement('span', 'RuProductBundleProduct__priceSale', formatMoney(salePrice, self.data.moneyFormat)));
        if (salePrice < firstVariant.price) {
          price.appendChild(createElement('span', 'RuProductBundleProduct__priceCompare', firstVariant.priceText || formatMoney(firstVariant.price, self.data.moneyFormat)));
        }
      }
      */
      info.appendChild(price);

      var controls = createElement('div', 'RuProductBundleProduct__controls');
      var onlyVariant = singleVariantProduct(product);
      var selected = self.state.selections[step.key];
      var selectedVariant = selected && String(selected.product.id) === String(product.id) ? selected.variant : null;
      var sizeSelector = createBundleSizeSelector(product, selectedVariant, onlyVariant);
      var select = sizeSelector.select;

      if (image && !onlyVariant) {
        image.setAttribute('role', 'button');
        image.setAttribute('tabindex', '0');
        image.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          sizeSelector.trigger.click();
        });
        image.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            sizeSelector.trigger.click();
          }
        });
      }

      var add = createElement('button', 'RuProductBundleProduct__add');
      add.type = 'button';
      var addButtonConfig = {
        iconUrl: self.addIconUrl,
        soldOutLabel: self.soldOutLabel
      };

      refreshProductAddButton(add, product, select, onlyVariant, addButtonConfig);

      select.addEventListener('change', function() {
        if (onlyVariant) return;
        refreshProductAddButton(add, product, select, onlyVariant, addButtonConfig);
      });

      add.addEventListener('click', function() {
        var variant = (product.variants || []).find(function(item) {
          return String(item.id) === String(select.value);
        });
        if (variant) {
          self.selectStep(step, product, variant);
        }
      });

      controls.appendChild(sizeSelector.wrap);
      controls.appendChild(add);
      card.appendChild(imageWrap);
      card.appendChild(info);
      card.appendChild(controls);
      grid.appendChild(card);
    });

    return grid;
  };

  ProductBundle.prototype.selectStep = function(step, product, variant) {
    this.clearValidationErrors();

    var previous = this.state.selections[step.key];
    var cartLineKey = null;
    var cartVariantId = null;

    if (previous && String(previous.product.id) === String(product.id)) {
      cartLineKey = previous.cartLineKey || null;
      cartVariantId = previous.cartVariantId != null ? previous.cartVariantId : null;
    }

    this.state.selections[step.key] = {
      product: product,
      variant: variant,
      cartLineKey: cartLineKey,
      cartVariantId: cartVariantId
    };

    var currentIndex = this.state.steps.findIndex(function(item) {
      return item.key === step.key;
    });

    if (currentIndex < this.state.steps.length - 1) {
      this.state.activeStep = currentIndex + 1;
    } else {
      this.state.activeStep = currentIndex;
    }

    this.persistSelections();
    this.render();
    this.scrollModalToTop();
  };

  ProductBundle.prototype.scrollModalToTop = function() {
    var steps = this.stepsWrapper;
    var dialog = this.modalDialog;
    var content = this.modal ? this.modal.querySelector('.RuProductBundleModal__content') : null;
    var top = this.modalSubtitle || (this.modal && this.modal.querySelector('#ru-bundle-modal-top'));

    window.requestAnimationFrame(function() {
      [steps, dialog, content].forEach(function(el) {
        if (!el) return;
        if (typeof el.scrollTo === 'function') {
          el.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          el.scrollTop = 0;
        }
      });

      if (top && typeof top.scrollIntoView === 'function') {
        top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }
    });
  };

  ProductBundle.prototype.clearStepSelection = function(step) {
    var self = this;
    var selection = this.state.selections[step.key];
    if (!selection) return;

    var cartLineKey = selection.cartLineKey;
    delete this.state.selections[step.key];

    var stepIndex = this.state.steps.findIndex(function(item) {
      return item.key === step.key;
    });

    if (stepIndex !== -1) {
      this.state.activeStep = stepIndex;
    }

    this.clearValidationErrors();
    this.persistSelections();

    var finish = function() {
      self.render();
      var section = self.stepsWrapper.querySelector('[data-ru-bundle-step="' + step.key + '"]');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    };

    if (cartLineKey) {
      this.changeCartLine(cartLineKey, 0)
        .then(function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function() {})
        .then(finish);
    } else {
      finish();
    }
  };

  ProductBundle.prototype.goToStep = function(step) {
    var stepIndex = this.state.steps.findIndex(function(item) {
      return item.key === step.key;
    });

    if (stepIndex === -1) return;

    this.state.activeStep = stepIndex;
    this.renderSteps();

    if (window.matchMedia('(max-width: 1007px)').matches && this.summary.classList.contains('is-expanded')) {
      this.collapseSummary();
    }

    var section = this.stepsWrapper.querySelector('[data-ru-bundle-step="' + step.key + '"]');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  ProductBundle.prototype.renderSummary = function() {
    var self = this;
    this.slotsWrapper.innerHTML = '';
    this.detailsWrapper.innerHTML = '';

    if (this.totalWrapper) {
      this.totalWrapper.innerHTML = '';
      this.totalWrapper.hidden = true;
    }

    var originalTotal = 0;
    var bundleTotal = 0;
    var selectionCount = Object.keys(this.state.selections).length;
    var isMobile = window.matchMedia('(max-width: 1007px)').matches;

    this.state.steps.forEach(function(step, stepIndex) {
      var selection = self.state.selections[step.key];

      if (selection) {
        var slot = createElement('div', 'RuProductBundleSlot');
        slot.setAttribute('data-ru-bundle-slot', String(stepIndex));

        if (selection.variant.image || selection.product.image) {
          var slotImage = createElement('img');
          slotImage.src = selection.variant.image || selection.product.image;
          slotImage.alt = selection.product.title;
          slot.appendChild(slotImage);
          slot.appendChild(createRemoveSelectionButton(self.removeLabel, function() {
            self.clearStepSelection(step);
          }));
        }

        self.slotsWrapper.appendChild(slot);
      } else {
        self.slotsWrapper.appendChild(createEmptyBundleSlot(step, stepIndex, function(targetStep) {
          self.goToStep(targetStep);
        }));
      }

      if (selection) {
        var originalPrice = selection.variant.price;
        var finalPrice = discountedPrice(originalPrice, self.state.pack.discountPercent);
        originalTotal += originalPrice;
        bundleTotal += finalPrice;

        var line = createElement('div', 'RuProductBundleSummary__line');

        var imageWrap = createElement('div', 'RuProductBundleSummary__lineImageWrap');
        var image = createElement('img', 'RuProductBundleSummary__lineImage');
        image.src = selection.variant.image || selection.product.image || self.data.productImage || '';
        image.alt = selection.product.title;
        imageWrap.appendChild(image);

        var info = createElement('div', 'RuProductBundleSummary__lineInfo ProductCartItem__Info');
        info.appendChild(createElement('p', 'RuProductBundleSummary__lineProduct', selection.product.title));

        if (selection.product.model) {
          info.appendChild(createElement('p', 'CartProductItem__ModelName', selection.product.model));
        }

        var variantText = variantLabel(selection.variant) || (selection.variant.title !== 'Default Title' ? selection.variant.title : '');
        if (variantText) {
          info.appendChild(createElement('p', 'CartItem__Variant Text--subdued', variantText));
        }

        var price = createElement('div', 'RuProductBundleSummary__linePrice CartItem__PriceList');
        appendStorefrontVariantPrice(price, selection.variant, self.data.moneyFormat, {
          saleClass: 'RuProductBundleSummary__lineSale',
          compareClass: 'RuProductBundleSummary__lineCompare',
          onSaleContainerClass: 'RuProductBundleSummary__linePrice--onSale'
        });

        var actions = createElement('div', 'RuProductBundleSummary__lineActions');
        var modify = createElement('button', 'RuProductBundleSummary__modify', self.modifyLabel);
        modify.type = 'button';
        modify.addEventListener('click', function(event) {
          event.preventDefault();
          self.goToStep(step);
        });
        var remove = createRemoveSelectionButton(self.removeLabel, function() {
          self.clearStepSelection(step);
        });
        actions.appendChild(modify);
        actions.appendChild(remove);

        var aside = createElement('div', 'RuProductBundleSummary__lineAside');
        aside.appendChild(price);
        aside.appendChild(actions);

        var main = createElement('div', 'RuProductBundleSummary__lineMain');
        main.appendChild(info);
        main.appendChild(aside);

        line.appendChild(imageWrap);
        line.appendChild(main);
        self.detailsWrapper.appendChild(line);
      } else if (!isMobile) {
        // Desktop list: pending step placeholders (same shortcut as mobile slots).
        var placeholder = createEmptyBundleSlot(step, stepIndex, function(targetStep) {
          self.goToStep(targetStep);
        });
        placeholder.classList.add('RuProductBundleSummary__placeholder');
        self.detailsWrapper.appendChild(placeholder);
      }
    });

    // Mobile collapsed: keep empty until at least one product is selected (image 1).
    this.slotsWrapper.hidden = isMobile && selectionCount === 0;
    this.slotsWrapper.classList.toggle('is-empty', selectionCount === 0);

    if (selectionCount) {
      var savings = Math.max(0, originalTotal - bundleTotal);
      var total = createElement('div', 'RuProductBundleSummary__total');
      var totalPrices = createElement('div', 'RuProductBundleSummary__totalPrices');
      var totalRow = createElement('div', 'RuProductBundleSummary__totalRow');

      total.appendChild(createElement('span', 'RuProductBundleSummary__totalLabel', 'TOTAL:'));

      if (originalTotal > bundleTotal) {
        totalPrices.appendChild(createElement('span', 'RuProductBundleSummary__totalCompare', formatMoney(originalTotal, this.data.moneyFormat)));
      }

      totalRow.appendChild(createElement('span', 'RuProductBundleSummary__totalBadge', 'PACKAHORRO -' + formatMoney(savings, this.data.moneyFormat)));
      totalRow.appendChild(createElement('strong', 'RuProductBundleSummary__totalFinal', formatMoney(bundleTotal, this.data.moneyFormat)));
      totalPrices.appendChild(totalRow);
      total.appendChild(totalPrices);

      var totalParent = this.totalWrapper || this.detailsWrapper;
      totalParent.appendChild(total);

      if (this.totalWrapper) {
        this.totalWrapper.hidden = false;
      }
    }

    // Desktop always shows details (placeholders and/or lines). Mobile only when expanded.
    this.detailsWrapper.hidden = isMobile && !this.summary.classList.contains('is-expanded');

    if (this.summaryToggle) {
      this.summaryToggle.setAttribute('aria-expanded', String(this.summary.classList.contains('is-expanded')));
    }

    var isComplete = selectionCount === this.state.steps.length;
    if (isComplete) {
      this.submitButton.classList.remove('is-disabled');
      this.submitButton.setAttribute('aria-disabled', 'false');
    } else {
      this.submitButton.classList.add('is-disabled');
      this.submitButton.setAttribute('aria-disabled', 'true');
    }

    if (!this.submitButton.classList.contains('is-loading')) {
      this.submitButton.disabled = false;
    }
  };

  ProductBundle.prototype.changeCartLine = function(lineKey, quantity) {
    return fetch(this.getCartChangeUrl(), {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    }).then(function(response) {
      if (!response.ok) throw new Error('Cart change failed');
      return response.json();
    });
  };

  ProductBundle.prototype.syncBundleToCart = function(cart) {
    var self = this;
    var removals = [];
    var additions = [];

    this.state.steps.forEach(function(step) {
      var selection = self.state.selections[step.key];
      if (!selection) return;

      var variantId = Number(selection.variant.id);
      var matchingLine = self.findCartItemByVariantId(cart, variantId);

      if (selection.cartLineKey) {
        if (String(selection.cartVariantId) === String(variantId)) {
          return;
        }

        removals.push(selection.cartLineKey);

        if (!matchingLine) {
          additions.push({ id: variantId, quantity: 1 });
        }

        return;
      }

      if (matchingLine) {
        return;
      }

      additions.push({ id: variantId, quantity: 1 });
    });

    var chain = Promise.resolve();

    removals.forEach(function(lineKey) {
      chain = chain.then(function() {
        return self.changeCartLine(lineKey, 0);
      });
    });

    return chain.then(function() {
      if (!additions.length) return null;

      return fetch(self.getCartAddUrl(), {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: additions })
      }).then(function(response) {
        if (!response.ok) throw new Error('Bundle add to cart failed');
        return response.json();
      });
    });
  };

  ProductBundle.prototype.addToCart = function() {
    var self = this;
    if (!this.state.pack || this.submitButton.classList.contains('is-disabled')) return;

    if (this.state.steps.length !== Object.keys(this.state.selections).length) return;

    var defaultLabel = this.submitButton.getAttribute('data-default-label') || this.submitButton.textContent;
    this.submitButton.setAttribute('data-default-label', defaultLabel);
    this.submitButton.classList.add('is-loading');
    this.submitButton.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var firstAddedVariantId = null;

    this.state.steps.some(function(step) {
      var selection = self.state.selections[step.key];
      if (selection && !selection.cartLineKey) {
        firstAddedVariantId = Number(selection.variant.id);
        return true;
      }
      if (selection && selection.cartLineKey && String(selection.cartVariantId) !== String(selection.variant.id)) {
        firstAddedVariantId = Number(selection.variant.id);
        return true;
      }
      return false;
    });

    this.fetchCart()
      .then(function(cart) {
        return self.syncBundleToCart(cart);
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (firstAddedVariantId) {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: { id: firstAddedVariantId },
              quantity: 1
            }
          }));
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        self.closeModal();
      })
      .catch(function() {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        self.submitButton.classList.remove('is-loading');
        self.renderSummary();
        self.submitButton.textContent = 'ERROR - INTENTALO DE NUEVO';
        setTimeout(function() {
          self.submitButton.textContent = defaultLabel;
        }, 2200);
      });
  };

  function init() {
    Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR)).forEach(function(root) {
      if (!root.ruProductBundle) {
        root.ruProductBundle = new ProductBundle(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
